import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './EServices.css';
import GrayPanel from '../../components/GrayPanel';

class UserInfo extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};

  }

  render() {
    // layout classes
    const leftCol = 'col-sm-2';
    const labelCol = 'col-sm-2';
    const inputCol = 'col-sm-6';
    const rightCol = 'col-sm-2';

    // really simple styles
    const labelStyle = { marginTop: '.5rem' };
    const rowStyle = { marginTop: '15px' };
    const formDict = {
      FirstName: {
        label: 'Imię',
      },
      LastName: {
        label: 'Nazwisko',
      },
      FullName: {
        label: 'Nazwa wnioskodawcy',
      },
      AddressCity: {
        label: 'Miejscowość',
      },
      AddressStreet: {
        label: 'Ulica',
      },
      AddressFlat: {
        label: 'Numer lokalu',
      },
      AddressNumber: {
        label: 'Numer budynku',
      },
      AddressZipCode: {
        label: 'Kod pocztowy',
      },
      Email: {
        label: 'Email',
      },
    };
    return this.props.userInfo ? <GrayPanel title="Dane wnioskodawcy: ">
      {Object.keys(formDict).map((v, i) => {
        return (
          <div className="row" key={i} style={rowStyle}>
            <div className={leftCol} />
            <div className={labelCol}>
              <label style={labelStyle}>{formDict[v].label}</label>
            </div>
            <div className={inputCol}>
              <input className="form-control" value={this.props.userInfo[v] ? this.props.userInfo[v] : ''} disabled />
            </div>
            <div className={rightCol} />
          </div>
        );
      })}
    </GrayPanel> : null;
  }
};

UserInfo.propTypes = {
  userInfo: PropTypes.object,
};

export default withStyles(s)(UserInfo);



// WEBPACK FOOTER //
// src/routes/eservices/UserInfo.js